import { render, staticRenderFns } from "./GrowthIndex.vue?vue&type=template&id=a6d19990&scoped=true"
import script from "./GrowthIndex.vue?vue&type=script&lang=js"
export * from "./GrowthIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d19990",
  null
  
)

export default component.exports